import { analytics } from '@modules/analytics';
import { Box } from '@ui-lib';
import { type MouseEventHandler, type ReactNode, useCallback } from 'react';

import { lockBlockButtonRecipe } from './LockBlockButton.css';

interface LockBlockButtonProps {
  locked?: boolean;
  canLock?: boolean;
  position: 'top-right';
  onClick: MouseEventHandler;
  icon: ReactNode;
}

export const LockBlockButton = ({
  ref,
  position,
  onClick,
  locked,
  canLock,
  icon,
}: LockBlockButtonProps & {
  ref?: React.Ref<HTMLButtonElement>;
}) => {
  const handleClick = useCallback<MouseEventHandler>(
    (e) => {
      analytics.track({ name: 'picturelockbutton_clicked' });
      onClick(e);
    },
    [onClick],
  );

  return (
    <Box
      ref={ref}
      disabled={!canLock}
      component="button"
      onClick={handleClick}
      className={lockBlockButtonRecipe({
        locked,
        position,
      })}
    >
      {icon}
    </Box>
  );
};

LockBlockButton.displayName = 'LockBlockButton';
